import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export default function useUrlHash(query: string) {
  const { hash } = useLocation();
  const memo = useMemo(() => new URLSearchParams(hash), [hash]);
  return memo.get(query);
}
